import {Tuti} from '../../tuti/js/Tuti';

Tuti.ready(() => {
  const body = document.querySelector('.layout-body');
  const sidebarContent = document.querySelector('.layout-sidebar__content');

  if (body) {
    const bodyClassList = body.classList;

    bodyClassList.remove('no-js');

    [].forEach.call(document.querySelectorAll('.js-burger'), (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        const bitrixPanel = document.getElementById('panel');
        const classList = item.classList;

        if (classList.contains('icon-burger_open')) {
          classList.remove('icon-burger_open');
          bodyClassList.remove('js-menu-visible');
          sidebarContent.style.top = 'auto';
        } else {
          classList.add('icon-burger_open');
          bodyClassList.add('js-menu-visible');

          if (bitrixPanel) {
            sidebarContent.style.top = 60 + bitrixPanel.clientHeight + 'px';
          } else {
            sidebarContent.style.top = 60 + 'px';
          }
        }
      });
    });

    const searchOpen = document.querySelectorAll('.js-sidebar-search-btn');

    [].forEach.call(searchOpen, (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        bodyClassList.toggle('js-search-visible');
      });
    });
  }
});
